import Superagent from 'superagent';

/**
 * App Initialization component. This gets config info from the 
 * config.json file to get the set of featured questions and solver
 * details.
 */
const AppInit = {

  getConfig() {
    return new Promise((resolve, reject) => {
       Superagent.get('/assets/config.json').end((err, response) => {
         if (!err && response) {
           // Enclose in try block to catch possible JSON parse
           // exception.
           try {
             const config = JSON.parse(response.text);
             if (!config.featuredQuestions) {
               reject("Application Configuration Error! Missing Featured Questions to display.");
             } else {
               resolve(config);
             } 
           } catch (e) {
             reject(e.message);
           }
         }
       })
    })
  },
}

export default AppInit;
